<template lang="pug">
  table#tbInventariosFisicos.table.is-striped.is-responsive.is-narrow
    thead
      tr
        th(colspan=3 align="center") Capacidad Disponible
      tr
        th(align="center") Cap. Total T.M.
        th(align="center") Cap. Disp. T.M.
        th(align="center") %
    tbody
      tr
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium  3,900.00
        td(align="center") 
          span.tag.is-light.is-size-6.has-text-weight-medium {{ disponible | numberFormatDecimal }}
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium {{ porcentajeDisp }}
</template>

<script>
  import Decimal from 'decimal.js'
  export default {
    name: 'TbCapacidadDisponible',
    props: {
      data: {
        type: Array,
        default: [],
      },
    },
    data() {
      return {
        capacidad: 3900,
        disponible: 0,
        porcentajeDisp: 0,
      }
    },
    watch: {
      data() {
        this.getData()
      }
    },
    methods: {
      getData() {
        if (Object.keys(this.data).length > 0) {
          const masaA = new Decimal(this.data[0].volTon)
          const masaB = new Decimal(this.data[1].volTon)
          const total = masaA.plus(masaB).toFixed(2)
          const disp = new Decimal(this.capacidad).minus(total)
          this.disponible = disp
          const capacity = new Decimal(this.capacidad)
          const porc = disp.times(100).dividedBy(capacity).toFixed(2)
          this.porcentajeDisp = porc
        } else {
          this.disponible = 0
          this.porcentajeDisp = 0
        }
      },
    },
    created () {
      this.getData()
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/dashboard/componentes/Tb_CapacidadDisponible.vue